import React from "react";
import {Message, Modal} from "semantic-ui-react";
import {STRATEGIC_PARTNER} from "../../constants/strategicPartners";
import {CustomModalHeader} from "../custom-common";

const { LEGAL: { SERVICE_NAME} } = STRATEGIC_PARTNER;

const PaperCheckModal = ({ strings, size = "small", onClose, open, msgText = null, msgType = "warning", children }) => {
    return (
        <Modal onClose={onClose} open={open} size={size}>
            <CustomModalHeader title={strings.mailInYourPayment} onClose={onClose}/>
            <Modal.Content style={{maxHeight:'513px', overflowY:'auto'}}>
                {!!msgText && <Message style={{border: "none", borderRadius: 0}} content={msgText} {...{[msgType]: true}} />}
                <p>{strings.preferToMailInA}</p>
                <p>{strings.checksShouldBe}</p>
                <p>
                    <span className="primaryHeaderColor" style={{fontWeight: "bold"}}>{strings.mailTo}</span><br />
                    {SERVICE_NAME}<br />
                    P.O. Box 735880<br />
                    Dallas, TX, 75373-5880
                </p>
                <a href >{strings.downloadPDF}</a>
            </Modal.Content>
            {children}
        </Modal>
    )
}

export default PaperCheckModal;
